// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExternalTemplateLiteDto
 */
export interface IExternalTemplateLiteDto {
    /**
     * 
     * @type {number}
     * @memberof IExternalTemplateLiteDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IExternalTemplateLiteDto
     */
    template_description?: string;
    /**
     * 
     * @type {string}
     * @memberof IExternalTemplateLiteDto
     */
    notification_type?: IExternalTemplateLiteDtoNotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IExternalTemplateLiteDto
     */
    category_type?: IExternalTemplateLiteDtoCategoryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IExternalTemplateLiteDto
     */
    notification_description?: string;
    /**
     * 
     * @type {string}
     * @memberof IExternalTemplateLiteDto
     */
    user_type?: IExternalTemplateLiteDtoUserTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IExternalTemplateLiteDtoNotificationTypeEnum {
    SIGN_UP = 'SIGN_UP',
    FORGOT_PASSWORD = 'FORGOT_PASSWORD',
    WELCOME_ABOARD = 'WELCOME_ABOARD',
    BENEFICIARY_CHANGES = 'BENEFICIARY_CHANGES',
    TRANSFER_OF_ASSETS_UPDATES = 'TRANSFER_OF_ASSETS_UPDATES',
    CARD_STATUS_CHANGE = 'CARD_STATUS_CHANGE',
    PROFILE_UPDATE = 'PROFILE_UPDATE',
    PAYMENT_METHOD_UPDATE = 'PAYMENT_METHOD_UPDATE',
    CLAIM_ACTIVITY_ACTION = 'CLAIM_ACTIVITY_ACTION',
    CARD_TRANSACTION_ALERT = 'CARD_TRANSACTION_ALERT',
    PASSWORD_CHANGED = 'PASSWORD_CHANGED',
    CLAIM_ACTIVITY_NO_ACTION = 'CLAIM_ACTIVITY_NO_ACTION',
    CONTRIBUTION_INVOICE_READY = 'CONTRIBUTION_INVOICE_READY',
    REPLENISHMENT_INVOICE_READY = 'REPLENISHMENT_INVOICE_READY',
    CARD_ACTIVATION_REMINDER = 'CARD_ACTIVATION_REMINDER',
    TRIGGER_MET = 'TRIGGER_MET',
    ORPHAN = 'ORPHAN',
    CLOSED_ACCOUNT = 'CLOSED_ACCOUNT',
    ACH_REJECTED = 'ACH_REJECTED',
    PRE_FUND = 'PRE_FUND',
    INDIVIDUAL_CONTRIBUTION = 'INDIVIDUAL_CONTRIBUTION',
    FILE_PROCESSED_SUCCESSFULLY = 'FILE_PROCESSED_SUCCESSFULLY',
    STATEMENT_GENERATED = 'STATEMENT_GENERATED',
    CIP_FAILED = 'CIP_FAILED',
    INDIVIDUAL_CONTRIBUTION_REMINDER = 'INDIVIDUAL_CONTRIBUTION_REMINDER',
    CARD_DECLINE_ACTIVATION_NEEDED = 'CARD_DECLINE_ACTIVATION_NEEDED',
    OUTSTANDING_CHECK_REMINDER = 'OUTSTANDING_CHECK_REMINDER',
    CARD_DECLINE_LOST_STOLEN = 'CARD_DECLINE_LOST_STOLEN',
    CARD_DECLINE_LOCKED_FROZEN = 'CARD_DECLINE_LOCKED_FROZEN',
    CHECK_VOID = 'CHECK_VOID',
    AUTOMATIC_INVESTMENTS = 'AUTOMATIC_INVESTMENTS',
    CARD_DECLINE_WALMART = 'CARD_DECLINE_WALMART',
    CARD_DECLINE_NON_HEALTHCARE = 'CARD_DECLINE_NON_HEALTHCARE',
    REIMBURSEMENT_FAILED = 'REIMBURSEMENT_FAILED',
    CARD_DECLINE_CVS_NOT_ALLOWED = 'CARD_DECLINE_CVS_NOT_ALLOWED',
    CARD_DECLINE_NOT_ENOUGH_BALANCE = 'CARD_DECLINE_NOT_ENOUGH_BALANCE',
    CARD_DECLINE_PLAN_NOT_STARTED = 'CARD_DECLINE_PLAN_NOT_STARTED',
    CHECK_EXPIRED = 'CHECK_EXPIRED',
    CARD_DECLINE_NO_AVAILABLE_BALANCE = 'CARD_DECLINE_NO_AVAILABLE_BALANCE',
    CARD_DECLINE_GENERIC = 'CARD_DECLINE_GENERIC',
    INDIVIDUAL_CONTRIBUTION_FAILED = 'INDIVIDUAL_CONTRIBUTION_FAILED',
    CARD_DECLINE_PAST_PLAN_END_DATE = 'CARD_DECLINE_PAST_PLAN_END_DATE',
    ISO_NEEDS_HELP = 'ISO_NEEDS_HELP',
    CARD_DECLINE_PIN_INVALID = 'CARD_DECLINE_PIN_INVALID',
    ISO_ORG_LOCKED = 'ISO_ORG_LOCKED',
    ISO_OVERLIMIT = 'ISO_OVERLIMIT',
    PHONE_VERIFICATION = 'PHONE_VERIFICATION',
    MFA_SMS = 'MFA_SMS',
    MFA_EMAIL = 'MFA_EMAIL',
    CARD_DECLINE_NOT_ALLOWED_SERVICE_FOR_PLAN = 'CARD_DECLINE_NOT_ALLOWED_SERVICE_FOR_PLAN',
    EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
    FORGOT_USERNAME = 'FORGOT_USERNAME',
    CARD_DECLINE_PEND_CONTRIBUTIONS = 'CARD_DECLINE_PEND_CONTRIBUTIONS',
    CARD_DECLINE_PEND_CONTRIBUTIONS_AND_CIP = 'CARD_DECLINE_PEND_CONTRIBUTIONS_AND_CIP',
    COMPLETE_SETUP = 'COMPLETE_SETUP',
    EMPLOYEE_ELECTION_NEEDED = 'EMPLOYEE_ELECTION_NEEDED',
    END_PLAN_YEAR_INITIAL = 'END_PLAN_YEAR_INITIAL',
    LOCKBOX_INBOUND_TOA_PROCESSED = 'LOCKBOX_INBOUND_TOA_PROCESSED',
    CONTACT_INFO_UPDATED = 'CONTACT_INFO_UPDATED',
    SCHEDULED_CONTRIBUTION = 'SCHEDULED_CONTRIBUTION',
    END_PLAN_YEAR_REMINDER = 'END_PLAN_YEAR_REMINDER',
    CLAIM_OFFSET = 'CLAIM_OFFSET',
    LOCKBOX_OUTBOUND_TOA_PENDING_INVESTMENTS = 'LOCKBOX_OUTBOUND_TOA_PENDING_INVESTMENTS',
    LOCKBOX_OUTBOUND_TOA_PROCESSED = 'LOCKBOX_OUTBOUND_TOA_PROCESSED',
    NEW_BANK_ACCOUNT_ADDED = 'NEW_BANK_ACCOUNT_ADDED',
    SMS_CONTACT_VERIFICATION = 'SMS_CONTACT_VERIFICATION',
    EMAIL_CONTACT_VERIFICATION = 'EMAIL_CONTACT_VERIFICATION',
    BANK_ACCOUNT_VERIFICATION_STATUS_CHANGE = 'BANK_ACCOUNT_VERIFICATION_STATUS_CHANGE',
    PERSON_ACCOUNTS_LINKED = 'PERSON_ACCOUNTS_LINKED',
    TAX_FORMS = 'TAX_FORMS',
    PRE_FUND_PUSH = 'PRE_FUND_PUSH',
    CARD_DECLINE_DATA_ENTERED_INCORRECTLY = 'CARD_DECLINE_DATA_ENTERED_INCORRECTLY',
    DUPLICATE_FILE_FOUND = 'DUPLICATE_FILE_FOUND',
    INTERNAL_FEEDBACK = 'INTERNAL_FEEDBACK',
    BENEFICIARY_UPDATE = 'BENEFICIARY_UPDATE',
    RENEWAL_INITIAL = 'RENEWAL_INITIAL',
    CIP_FAILED_CLOSED_ACCOUNT = 'CIP_FAILED_CLOSED_ACCOUNT',
    CARD_DECLINE_TEMPORARY_BLOCKED_MERCHANT = 'CARD_DECLINE_TEMPORARY_BLOCKED_MERCHANT',
    CARD_DECLINE_PERMANENTLY_BLOCKED_MERCHANT = 'CARD_DECLINE_PERMANENTLY_BLOCKED_MERCHANT',
    RENEWAL_REQUEST = 'RENEWAL_REQUEST',
    CARD_DECLINE_TERMINATED_EMPLOYEE = 'CARD_DECLINE_TERMINATED_EMPLOYEE',
    CARD_DECLINE_TERMINATED_EMPLOYER = 'CARD_DECLINE_TERMINATED_EMPLOYER',
    CARD_DECLINE_ORPHANED_EMPLOYEE = 'CARD_DECLINE_ORPHANED_EMPLOYEE',
    RENEWAL_REMINDER = 'RENEWAL_REMINDER',
    SCHEDULED_REPORT = 'SCHEDULED_REPORT',
    PUSH_PROVISIONING = 'PUSH_PROVISIONING',
    EXCESS_CONTRIBUTION = 'EXCESS_CONTRIBUTION',
    EOY_SHORTAGE_PULL = 'EOY_SHORTAGE_PULL',
    EOY_SHORTAGE_PUSH = 'EOY_SHORTAGE_PUSH',
    RETURN_UNUSED_FUNDS = 'RETURN_UNUSED_FUNDS',
    CONTRIBUTION_RETURN_PUSH_PULL = 'CONTRIBUTION_RETURN_PUSH_PULL',
    COMBINE_HSA = 'COMBINE_HSA',
    AUTHORIZED_USER = 'AUTHORIZED_USER',
    RETURNED_MAIL = 'RETURNED_MAIL',
    BAF_COLLECT_PULL = 'BAF_COLLECT_PULL',
    BAF_COLLECT_PUSH = 'BAF_COLLECT_PUSH',
    BAF_RETURN_PULL_PUSH = 'BAF_RETURN_PULL_PUSH',
    CARD_DECLINE_LOCKED_CARD_PURSE = 'CARD_DECLINE_LOCKED_CARD_PURSE',
    RETURNED_CHECK = 'RETURNED_CHECK'
}
/**
* @export
* @enum {string}
*/
export enum IExternalTemplateLiteDtoCategoryTypeEnum {
    WELCOME = 'WELCOME',
    ENROLLMENT_UPDATES = 'ENROLLMENT_UPDATES',
    HSA = 'HSA',
    INVESTMENTS = 'INVESTMENTS',
    REMINDERS = 'REMINDERS',
    CAMPAIGNS = 'CAMPAIGNS',
    CARD_STATUS = 'CARD_STATUS',
    PROFILE_UPDATES = 'PROFILE_UPDATES',
    ACCOUNT_ACTIVITY = 'ACCOUNT_ACTIVITY',
    ENROLLMENTS = 'ENROLLMENTS',
    INVOICE = 'INVOICE',
    TAX_FORMS = 'TAX_FORMS',
    FINANCE = 'FINANCE'
}
/**
* @export
* @enum {string}
*/
export enum IExternalTemplateLiteDtoUserTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    ADMIN = 'ADMIN'
}


/**
 * Check if a given object implements the IExternalTemplateLiteDto interface.
 */
export function instanceOfIExternalTemplateLiteDto(value: object): value is IExternalTemplateLiteDto {
    return true;
}

export function IExternalTemplateLiteDtoFromJSON(json: any): IExternalTemplateLiteDto {
    return IExternalTemplateLiteDtoFromJSONTyped(json, false);
}

export function IExternalTemplateLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExternalTemplateLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'template_description': json['template_description'] == null ? undefined : json['template_description'],
        'notification_type': json['notification_type'] == null ? undefined : json['notification_type'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'notification_description': json['notification_description'] == null ? undefined : json['notification_description'],
        'user_type': json['user_type'] == null ? undefined : json['user_type'],
    };
}

export function IExternalTemplateLiteDtoToJSON(json: any): IExternalTemplateLiteDto {
    return IExternalTemplateLiteDtoToJSONTyped(json, false);
}

export function IExternalTemplateLiteDtoToJSONTyped(value?: IExternalTemplateLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'template_description': value['template_description'],
        'notification_type': value['notification_type'],
        'category_type': value['category_type'],
        'notification_description': value['notification_description'],
        'user_type': value['user_type'],
    };
}

